import request from 'app-self-support-order/utils/request'
import api from 'app-self-support-order/common/api/setting'
import {stringify} from 'qs'

export async function getAutoRelateSetting() {
    return request(api.getAutoRelateSetting.url)
}

export async function setAutoRelateStatus(payload) {
    return request(api.setAutoRelateStatus.url, {
        method: api.setAutoRelateStatus.type,
        body: payload.body,
    })
}

export async function getAutoRelateUsers(params) {
    return request(`${api.getAutoRelateUsers.url}?${stringify(params)}`)
}

// 获取扩展资料中-自动绑定订单手机号-状态
export async function getBindPhoneStatus() {
    return request(api.getBindPhoneStatus.url)
}

// 变更扩展资料中-自动绑定订单手机号-状态
export async function setBindPhoneStatus(payload) {
    return request(api.setBindPhoneStatus.url, {
        method: api.setBindPhoneStatus.type,
        body: payload.body,
    })
}

// 获取扩展资料中-自动关联订单手机号-状态
export async function getRelatePhoneStatus() {
    return request(api.getRelatePhoneStatus.url)
}

// 变更扩展资料中-自动关联订单手机号-状态
export async function setRelatePhoneStatus(payload) {
    return request(api.setRelatePhoneStatus.url, {
        method: api.setRelatePhoneStatus.type,
        body: payload.body,
    })
}
